// extracted by mini-css-extract-plugin
export var disabled = "_y-a";
export var hierarchyLinkGray = "_y-4";
export var hierarchyLinkUnderline = "_y-3";
export var hierarchyPrimary = "_y-0";
export var hierarchySecondary = "_y-1";
export var hierarchyTertiary = "_y-2";
export var pressed = "_y-6";
export var themeAction = "_y-5";
export var themeDestructive = "_y-8";
export var themeNormal = "_y-7";
export var themeSuccess = "_y-9";